(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerTag = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      // Custom background color feature
      this.isMegaMenuOpen = false;
      this.handleSummaryClick = this.handleSummaryClick.bind(this);
      this.handleToggle = this.handleToggle.bind(this);
      this.initSummaryClickListener();

      this.inlineMenuItems = document.querySelectorAll(".mega-menu");
      this.megaMenuContent = document.querySelectorAll('.mega-menu__content');
      this.isHoveringMenu = false;
      this.hoverTimeout = null;

      this.createObserver();
      this.initEvents();
    }

    initEvents() {
      this.inlineMenuItems.forEach((item) => {
        item.addEventListener('mouseover', () => {
          this.handleMouseOver(item);
      });

        item.addEventListener('mouseleave', () => {
          this.handleMouseLeave();
        });
      });

      this.megaMenuContent.forEach((content) => {
        content.addEventListener('mouseover', () => {
          clearTimeout(this.hoverTimeout);
          this.isHoveringMenu = true;
        });

        content.addEventListener('mouseleave', () => {
          this.hoverTimeout = setTimeout(() => {
            this.isHoveringMenu = false;
            this.closeMenu();
          }, 100);
        });
      });
    }

    handleMouseOver(item) {
      if (this.currentItem && this.currentItem !== item) {
        this.currentItem.removeAttribute('open');
      }
      item.setAttribute('open', true);
      if (window.scrollY <= 650) {
        this.headerTag.classList.add('scrolled-background');
      }
      this.isHoveringMenu = true;
      this.currentItem = item;
      clearTimeout(this.hoverTimeout);
    }

    handleMouseLeave() {
      this.hoverTimeout = setTimeout(() => {
        this.isHoveringMenu = false;
        this.closeMenu();
      }, 100);
    }

    closeMenu() {
      if (!this.isHoveringMenu) {
        if (this.currentItem) {
          this.currentItem.removeAttribute('open');
        }

        if (window.scrollY <= 650) {
          this.headerTag.classList.remove('scrolled-background');
        }
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('summaryClicked', this.handleSummaryClick);

      document.querySelectorAll('[id^="Details-"]').forEach((details) => {
        details.removeEventListener('toggle', this.handleToggle);
      });
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    handleSummaryClick() {
      this.isMegaMenuOpen = true;
      this.headerTag.classList.add('scrolled-background');

      document.querySelectorAll('[id^="Details-"]').forEach((details) => {
        details.addEventListener('toggle', this.handleToggle);
      });
    }

    handleToggle(event) {
      this.isMegaMenuOpen = event.target.open;
      if (!event.target.open && window.scrollY <= 650) {
        this.headerTag.classList.remove('scrolled-background');
      }
    }

    initSummaryClickListener() {
      window.addEventListener('summaryClicked', this.handleSummaryClick);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 650 || this.isMegaMenuOpen) {
        this.headerTag.classList.add('scrolled-background');
      } else {
        this.headerTag.classList.remove('scrolled-background');
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
